const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const BoosterList = () => import(/* webpackChunkName: "booster" */ './view/index.vue');
const BoosterAdd = () => import(/* webpackChunkName: "booster" */ './view/add.vue');
const BoosterEdit = () => import(/* webpackChunkName: "booster" */ './view/edit.vue');

export const ROUTE_NAME_BOOSTER = {
    INDEX: 'BoosterList',
    ADD: 'BoosterAdd',
    EDIT: 'BoosterEdit'
};

export default [
    {
        path: '/app/:appId/booster',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_BOOSTER.INDEX,
                component: BoosterList,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_BOOSTER.ADD,
                component: BoosterAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':type/edit',
                name: ROUTE_NAME_BOOSTER.EDIT,
                component: BoosterEdit,
                meta: { requiresAuth: true }
            }
        ]
    }
];
